@import '~style-sheet-helpers/core.less';
@import '../../../constants/spacing.module.less';

.tagline {
  font-weight: 700;
}

.bullets {
  font-size: 14px;
  line-height: @space-24;
  margin-left: @space-12;
  padding-left: 0;
  list-style-type: none;

  li {
    list-style-type: none;
    position: relative;
    padding-left: 5px;
    margin-left: 5px;
    padding-top: @space-16;
    width: 100%;
  }

  li:before {
    content: '\2713 ';
    position: absolute;
    left: -15px;
  }
}
